import { Container, PageHeader } from "@/components/site/PageHeader";
import { DonateForm } from "@/components/site/DonateForm";
import { MEDIA_AGE } from "@/lib/brand";
import { GOALS, MemberCta, NumberedList, PhotoGrid, Stats, WHY } from "@/components/site/SupportSections";

const H2 = ({ top, bottom }) => (
  <h2 className="uppercase text-4xl md:text-5xl leading-[0.95]">
    <span className="font-display text-white block">{top}</span>
    <span className="font-thin-brand text-white block pl-[8%]">{bottom}</span>
  </h2>
);

export default function Support() {
  return (
    <>
      <PageHeader top="LGTDZ" bottom="se construit ici" testId="support-header"
        intro="Le triptyque radio - Twitch - évènements qui met en avant le groove exigeant. LGTDZ, un média qui parle de groove et de culture, autrement et en profondeur." />

      <Container className="pt-20">
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-primary mb-6">LGTDZ c'est quoi ?</p>
        <Stats />
        <p className="text-zinc-300 text-lg leading-relaxed max-w-3xl mt-10">
          {MEDIA_AGE} ans d'existence, des milliers d'articles, plus de 200 événements organisés, couverts ou animés, et un très vaste réseau international d'artistes accompagnés à différents stades de leur développement. Fort de toutes ces expériences, LGTDZ fait sa mue et entre définitivement dans sa phase de structuration. Toujours dans cette volonté de mettre l'art et les artistes au premier plan, avec le propos, la technique et la passion comme principaux critères.
        </p>
      </Container>

      <Container className="py-20 grid lg:grid-cols-2 gap-16" >
        <div className="space-y-16">
          <div>
            <H2 top="Pourquoi" bottom="s'abonner ?" />
            <div className="mt-10"><NumberedList items={WHY} testId="support-why" /></div>
          </div>
          <div>
            <H2 top="Dans quel" bottom="but ?" />
            <div className="mt-10"><NumberedList items={GOALS} testId="support-goals" /></div>
          </div>
          <p className="text-zinc-300 text-base md:text-lg leading-relaxed">
            Les fonds récoltés chaque mois serviront au renouvellement du matériel utilisé dans la production de nos contenus et l'organisation de nos événements. Les moyens vont permettre de concentrer les forces et maximiser le temps consacré à la rédaction, l'embauche d'une équipe et une montée globale en gamme dans l'ensemble de nos compétences et propositions.
          </p>
        </div>

        <aside className="lg:sticky lg:top-28 self-start space-y-6">
          <div className="border-2 border-primary p-6 md:p-10" data-testid="support-member-card">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-primary">Abonnements</p>
            <p className="font-display uppercase text-3xl md:text-4xl text-white mt-3 leading-tight">Rejoins la communauté dès 2&nbsp;€ par mois</p>
            <p className="text-zinc-400 mt-4 mb-8">Accès aux publications réservées aux membres, via notre page de financement participatif.</p>
            <MemberCta />
          </div>
          <div className="bg-[hsl(var(--surface))] border border-white/10 p-6 md:p-10">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-primary">Ou fais un simple don</p>
            <p className="text-zinc-400 mt-3 mb-8">Tu adores LGTDZ mais ne cherches pas à avoir accès aux publications réservées ? Fais un don unique.</p>
            <DonateForm />
          </div>
        </aside>
      </Container>

      <Container className="pb-24">
        <H2 top="Sur le" bottom="terrain" />
        <div className="mt-10"><PhotoGrid /></div>
      </Container>
    </>
  );
}
